import { skipToken } from '@reduxjs/toolkit/query';
import { useMemo } from 'react';

import { useAppSelector } from '@verantos-dev/core-annotation-tool';

import { useGetAnnotationAgentConceptLabelsQuery } from '../../api/createProjectApiSlice';
import { useIsAgentStepEnabled } from '../../hooks/useCreateProjectWizardSteps';
import {
  selectAddedConcepts,
  selectAnnotationAgentConcepts,
  selectConditionArea,
} from '../../state/selector';
import { getAgentConceptsInStep2Order } from '../../utils/getAgentConceptsInStep2Order';

// TODO: cleanup with cp_annotation_createproject_agent ff

const NO_LABELS: Record<string, string> = {};

/**
 * The prompt label of each step 2 concept group, by concept group ID. The server takes them
 * from the label table and adds the ones that are missing, so these are the labels the
 * rendered prompt uses. Empty until the response arrives.
 */
export const useAgentConceptLabels = (): Record<string, string> => {
  const isAgentStepEnabled = useIsAgentStepEnabled();
  const conditionArea = useAppSelector(selectConditionArea);
  const addedConcepts = useAppSelector(selectAddedConcepts);
  const concepts = useAppSelector(selectAnnotationAgentConcepts);

  const conceptGroupIds = useMemo(
    () =>
      getAgentConceptsInStep2Order(addedConcepts, concepts).map(
        ({ conceptGroupId }) => conceptGroupId
      ),
    [addedConcepts, concepts]
  );

  // With the flag off the step does not exist, so nothing is requested.
  const { data } = useGetAnnotationAgentConceptLabelsQuery(
    isAgentStepEnabled && conditionArea && conceptGroupIds.length > 0
      ? { conditionAreaId: conditionArea.id, conceptGroupIds }
      : skipToken
  );

  return data?.data.labels ?? NO_LABELS;
};
